import {
  doc,
  updateDoc,
  collection,
  writeBatch,
  increment,
  getDoc,
} from "firebase/firestore";
import { db } from "../firebase";

// 🔥 MAIN FUNCTION
export const decideWinners = async ({
  tournamentId,
  participants,
  tournamentData,
  collectionType,
  selectedTeams,
  teamKills,
}) => {
  const docRef = doc(db, collectionType, tournamentId);

  const docSnap = await getDoc(docRef);
  if (!docSnap.exists()) return;

  const data = docSnap.data();

  const totalSpots = data.totalSpots || 0;
  const totalPlayers = participants.length;

  // ================= ❌ REFUND =================
  if (totalPlayers < totalSpots) {
    if (data.refunded) return;

    const batch = writeBatch(db);
    const entryFee = Number(data.entryFee || 0);

    for (let p of participants) {
      if (!p.userId) continue;

      const userRef = doc(db, "users", p.userId);
      const txnRef = doc(collection(userRef, "transactions"));

      batch.update(userRef, {
        withdrawable: increment(entryFee),
      });

      batch.set(txnRef, {
        amount: entryFee,
        type: "credit",
        status: "completed",
        description: "Match cancelled - refund",
        tournamentId,
        timestamp: new Date(),
      });
    }

    batch.update(docRef, {
      status: "cancelled",
      refunded: true,
      winnerDeclared: false,
    });

    await batch.commit();
    return;
  }

  // ================= 🏆 WINNER =================

  const prizePool = Number(data.prizePool || 0);
  const perKill = Number(data.perKill || 0);

  const teams = {};

  // 🔥 group teams
  participants.forEach((p) => {
    if (!teams[p.team]) teams[p.team] = [];
    teams[p.team].push(p);
  });

  const selected = Object.keys(selectedTeams).filter(
    (t) => selectedTeams[t]
  );

  if (!selected.length) return;

  const batch = writeBatch(db);

  const prizePerTeam = prizePool / selected.length;

  let winnersList = [];
  let winnerUids = new Set();
  let allUids = new Set();

  participants.forEach((p) => {
    if (p.userId) allUids.add(p.userId);
  });

  for (let team of selected) {
    const members = teams[team] || [];

    const kills = Number(teamKills[team] || 0);
    const killsBonus = perKill * kills;

    const prizeShare = prizePerTeam;
    const totalTeamPrize = prizeShare + killsBonus;

    const perUser = members.length
      ? totalTeamPrize / members.length
      : 0;

    const teamUids = [];

    for (let m of members) {
      if (!m.userId) continue;

      teamUids.push(m.userId);
      winnerUids.add(m.userId);

      const userRef = doc(db, "users", m.userId);
      const txnRef = doc(collection(userRef, "transactions"));

      batch.update(userRef, {
        withdrawable: increment(perUser),
      });

      batch.set(txnRef, {
        amount: perUser,
        type: "credit",
        status: "completed",
        description: `Tournament Win - ${data.title}`,
        tournamentId,
        teamNumber: Number(team),
        paymentMethod: "tournament_prize",
        timestamp: new Date(),
      });
    }

    winnersList.push({
      teamNumber: Number(team),
      teamMembersCount: members.length,
      kills,
      killsBonus,
      prizeShare,
      totalEarnings: totalTeamPrize,
      winningUserIds: teamUids,
      declaredAt: new Date(),
    });
  }

  const loserUids = [...allUids].filter(
    (id) => !winnerUids.has(id)
  );

  // ================= 🔔 NOTIFICATION =================
  console.log("Winners:", [...winnerUids]);
  console.log("Losers:", loserUids);

  // 👉 yaha API laga sakta hai
  /*
  await fetch("/sendNotification", {
    method: "POST",
    body: JSON.stringify({
      winners: [...winnerUids],
      losers: loserUids,
    }),
  });
  */

  // ================= 💾 SAVE RESULT =================
  batch.set(
    doc(collection(docRef, "winners"), "result"),
    {
      winners: winnersList,
      totalWinners: selected.length,
      prizeDistribution: {
        prizePool,
      },
      declaredAt: new Date(),
      tournamentId,
    }
  );

  // ================= 🔄 UPDATE =================
  batch.update(docRef, {
    winnerDeclared: true,
    status: "completed",
  });

  await batch.commit();
};